import {
  Sparkles, ArrowUpCircle, Wrench, AlertTriangle, Megaphone, type LucideIcon,
} from 'lucide-react';
import type { AnnouncementType } from '@/services/announcements';

// Per-type visual config (icon + eyebrow label + accent classes), shared by the
// strip, toast, and "What's new" panel so the per-type look is defined once.
export interface AnnouncementTypeConfig {
  label: string;
  icon: LucideIcon;
  tintBg: string;
  tintBorder: string;
  accentText: string;
  ctaBg: string;
  dotBg: string;
}

export const ANNOUNCEMENT_TYPE_CONFIG: Record<AnnouncementType, AnnouncementTypeConfig> = {
  feature: {
    label: 'New feature', icon: Sparkles,
    tintBg: 'bg-blue-50', tintBorder: 'border-blue-100', accentText: 'text-blue-600', ctaBg: 'bg-blue-600 hover:bg-blue-700', dotBg: 'bg-blue-600',
  },
  improvement: {
    label: 'Improvement', icon: ArrowUpCircle,
    tintBg: 'bg-emerald-50', tintBorder: 'border-emerald-100', accentText: 'text-emerald-600', ctaBg: 'bg-emerald-600 hover:bg-emerald-700', dotBg: 'bg-emerald-600',
  },
  maintenance: {
    label: 'Scheduled maintenance', icon: Wrench,
    tintBg: 'bg-amber-50', tintBorder: 'border-amber-100', accentText: 'text-amber-700', ctaBg: 'bg-amber-600 hover:bg-amber-700', dotBg: 'bg-amber-700',
  },
  critical: {
    label: 'Action required', icon: AlertTriangle,
    tintBg: 'bg-red-50', tintBorder: 'border-red-100', accentText: 'text-red-700', ctaBg: 'bg-red-600 hover:bg-red-700', dotBg: 'bg-red-700',
  },
  promo: {
    label: 'Limited time', icon: Megaphone,
    tintBg: 'bg-blue-50', tintBorder: 'border-blue-100', accentText: 'text-blue-600', ctaBg: 'bg-blue-600 hover:bg-blue-700', dotBg: 'bg-blue-600',
  },
};

export function getAnnouncementTypeConfig(type: AnnouncementType): AnnouncementTypeConfig {
  return ANNOUNCEMENT_TYPE_CONFIG[type] ?? ANNOUNCEMENT_TYPE_CONFIG.feature;
}
